var typographyData = {
  name: 'typography',
  data: [{
    regularFontFamily: 'PingFangSC-Regular',
    mediumFontFamily: 'PingFangSC-Medium',
    semiboldFontFamily: 'PingFangSC-Semibold',
    // h1 style data
    h1FontSize: 24,
    h1FontWeight: 500,
    h1LineHeight: 32,
    h1Color: '#000000',
    // h2 style data
    h2FontSize: 16,
    h2FontWeight: 500,
    h2LineHeight: 24,
    h2Color: '#000000',
    // h3 style data
    h3FontSize: 14,
    h3FontWeight: 500,
    h3LineHeight: 22,
    h3Color: '#000000',
    // h4 style data
    h4FontSize: 14,
    h4FontWeight: 400,
    h4LineHeight: 22,
    h4Color: 'rgba(0, 0, 0, 0.45)',
    // h5 style data
    h5FontSize: 12,
    h5FontWeight: 400,
    h5LineHeight: 20,
    h5Color: 'rgba(0, 0, 0, 0.85)',
    // blockquote style data
    blockquoteFontSize: 14,
    blockquoteColor: '#686868',
    blockquoteLineHeight: 20,
    // link style data
    linkFontSize: 13,
    linkColor: '#4590ff',
    linkHoverColor: '#82BCF9',
    linkLineHeight: 0,
    // strong style data
    strongFontSize: 14,
    strongColor: '#1c1c1c',
    strongLineHeight: 20,
    strongFontWeight: 500,
    // mark style data
    markColor: '#f6b74d',
    // code style data
    codeFontSize: 14,
    codeBg: '#f6f6f8',
    codeBorderRadius: 2,
    codeBorder: 'none',
    codeColor: '#686868',
    // del style data
    delFontSize: 14,
    delColor: '#686868',
    // copy style dada
    copyMarginLeft: 9,
    // copy icon data
    copyIconColor: '#3889ff',
    copyIconFontSize: 12,
    // expand style data
    expandFontSize: 13,
    expandColor: '#3889ff',
    // text color data
    successColor: '#39C878',
    warningColor: '#F8B303',
    dangerColor: '#FD6868',
    // form style data
    formTypographyPadding: '0.03rem 0',
    formTypographyFontSize: 12,
    formTypographyLineHeight: 20
  }]
};
export default typographyData;